/**
 * Native-only haptics for Capacitor iOS/Android.
 * No-ops on web to avoid Capacitor's web fallback (navigator.vibrate).
 */

import { Haptics, ImpactStyle, NotificationType } from '@capacitor/haptics';
import { isCapacitorNative } from './platformUtils';

const run = async (fn: () => Promise<void>): Promise<void> => {
  if (!isCapacitorNative()) return;
  try {
    await fn();
  } catch {
    // Haptics disabled in settings or unavailable
  }
};

export const hapticLight = (): Promise<void> =>
  run(() => Haptics.impact({ style: ImpactStyle.Light }));

export const hapticMedium = (): Promise<void> =>
  run(() => Haptics.impact({ style: ImpactStyle.Medium }));

export const hapticHeavy = (): Promise<void> =>
  run(() => Haptics.impact({ style: ImpactStyle.Heavy }));

export const hapticSuccess = (): Promise<void> =>
  run(() => Haptics.notification({ type: NotificationType.Success }));

export const hapticWarning = (): Promise<void> =>
  run(() => Haptics.notification({ type: NotificationType.Warning }));

export const hapticError = (): Promise<void> =>
  run(() => Haptics.notification({ type: NotificationType.Error }));

export const hapticSelectionStart = (): Promise<void> =>
  run(() => Haptics.selectionStart());

export const hapticSelectionChanged = (): Promise<void> =>
  run(() => Haptics.selectionChanged());

export const hapticSelectionEnd = (): Promise<void> =>
  run(() => Haptics.selectionEnd());
